export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_evgPackingSchemeName') || '包装方案名称',
    field: 'evgPackingSchemeName',
    align: 'center',
    minWidth: 300,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_platform_cust') || '渠道/客户',
    field: 'platformName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'platformName' },
  },
  {
    title: that.$l('table_label_region') || '所属地区',
    field: 'regionName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dispatchPort') || '出运港口',
    field: 'dispatchPortName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_bookingType') || '订舱类型',
    field: 'v_bookingType',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_containerName') || '箱型',
    field: 'containerName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totQty') || '入柜总数',
    field: 'inContainerQty',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    slots: { default: 'inContainerQty' },
  },
  {
    title: that.$l('table_label_palletGrossWeight') || '单托毛重(KG)',
    field: 'palletGrossWeight',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_palletNetWeight') || '单托净重(KG)',
    field: 'palletNetWeight',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_palletVolumes') || '单托体积(m³)',
    field: 'palletVolumes',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_pallet') || '箱唛',
    field: 'palletItemNo',
    align: 'left',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    slots: { default: 'palletItemNo' },
  },
  {
    title: that.$l('table_label_totUnitInContainerQty') || '入柜产品总数',
    field: 'totUnitInContainerQty',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totSpecInContainerQty') || '入柜规格总数',
    field: 'totSpecInContainerQty',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totCntInContainerQty') || '入柜箱总数',
    field: 'totCntInContainerQty',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
